module.exports = __webpack_public_path__ + "img/plus-gray.33d362af.svg";